/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SavedCommoditiesCommitRow } from "./SavedCommoditiesCommitRow";
import {
  SavedCommoditiesCommitRowFromJSON,
  SavedCommoditiesCommitRowFromJSONTyped,
  SavedCommoditiesCommitRowToJSON,
  SavedCommoditiesCommitRowToJSONTyped,
} from "./SavedCommoditiesCommitRow";

/**
 *
 * @export
 * @interface SavedCommoditiesCommitResult
 */
export interface SavedCommoditiesCommitResult {
  /**
   *
   * @type {Array<SavedCommoditiesCommitRow>}
   * @memberof SavedCommoditiesCommitResult
   */
  rows: Array<SavedCommoditiesCommitRow>;
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesCommitResult
   */
  created: number;
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesCommitResult
   */
  updated: number;
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesCommitResult
   */
  skipped: number;
}

/**
 * Check if a given object implements the SavedCommoditiesCommitResult interface.
 */
export function instanceOfSavedCommoditiesCommitResult(
  value: object,
): value is SavedCommoditiesCommitResult {
  if (!("rows" in value) || value["rows"] === undefined) return false;
  if (!("created" in value) || value["created"] === undefined) return false;
  if (!("updated" in value) || value["updated"] === undefined) return false;
  if (!("skipped" in value) || value["skipped"] === undefined) return false;
  return true;
}

export function SavedCommoditiesCommitResultFromJSON(
  json: any,
): SavedCommoditiesCommitResult {
  return SavedCommoditiesCommitResultFromJSONTyped(json, false);
}

export function SavedCommoditiesCommitResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedCommoditiesCommitResult {
  if (json == null) {
    return json;
  }
  return {
    rows: (json["rows"] as Array<any>).map(SavedCommoditiesCommitRowFromJSON),
    created: json["created"],
    updated: json["updated"],
    skipped: json["skipped"],
  };
}

export function SavedCommoditiesCommitResultToJSON(
  json: any,
): SavedCommoditiesCommitResult {
  return SavedCommoditiesCommitResultToJSONTyped(json, false);
}

export function SavedCommoditiesCommitResultToJSONTyped(
  value?: SavedCommoditiesCommitResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rows: (value["rows"] as Array<any>).map(SavedCommoditiesCommitRowToJSON),
    created: value["created"],
    updated: value["updated"],
    skipped: value["skipped"],
  };
}
